import { render } from "./AccessoryConflict.vue?vue&type=template&id=36f039dd&scoped=true"
import script from "./AccessoryConflict.vue?vue&type=script&lang=js"
export * from "./AccessoryConflict.vue?vue&type=script&lang=js"

import "./AccessoryConflict.vue?vue&type=style&index=0&id=36f039dd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f039dd"]])

export default __exports__